module.exports = __webpack_public_path__ + "img/repeating_meshed_grid.668d7b67.png";